import { useFeatureIsOn } from '@growthbook/growthbook-react'

// GrowthBook flag key. Hardcoded locally because pantry-features can't reach
// the host app's `~/constants/flags.ts`. Must stay in sync with the host's
// `FLAGS.BS_ENABLE_CAMPAIGN_UPLIFT` entry.
export const BS_ENABLE_CAMPAIGN_UPLIFT = 'bs-enable-campaign-uplift'

// Gates the full Campaign Builder (Email campaigns, the Template and Audience
// steps, abandoned-cart reminder emails). Off = the reduced builder: only the
// Abandoned Cart type, the "Single Reminder" template applied for you, and
// Email 1 alone. Off is the safe default — `useFeatureIsOn` returns false
// when the flag is unknown or not yet loaded.
export const useEnableCampaignUplift = (): boolean =>
  useFeatureIsOn(BS_ENABLE_CAMPAIGN_UPLIFT)
